module.exports = __webpack_public_path__ + "static/files/continuum.c3b4274.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/continuum.png
// module id = aG9B
// module chunks = 0